(function () {
  const INTENT_WINDOW_MS = 8000;
  let lastIntentAt = 0;

  function markCartIntent() {
    lastIntentAt = Date.now();
  }

  function hasRecentCartIntent() {
    return Date.now() - lastIntentAt < INTENT_WINDOW_MS;
  }

  window.SootheeCartIntent = {
    mark: markCartIntent,
    recent: hasRecentCartIntent
  };

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (form && form.matches('form[action*="/cart/add"], product-form form')) {
        markCartIntent();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (
        target &&
        target.closest(
          'button[name="add"], [type="submit"][name="add"], a[href="/cart"], a[href^="/cart?"], #cart-icon-bubble, cart-remove-button, quantity-input button'
        )
      ) {
        markCartIntent();
      }
    },
    true
  );

  function guardNativeCartDrawer() {
    if (!window.customElements || !customElements.get('cart-drawer')) return;

    const CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || !CartDrawer.prototype || CartDrawer.prototype.__sootheeIntentGuarded) return;

    const originalOpen = CartDrawer.prototype.open;
    if (typeof originalOpen !== 'function') return;

    CartDrawer.prototype.open = function guardedOpen(triggeredBy) {
      const explicitCartTrigger =
        triggeredBy &&
        typeof triggeredBy.closest === 'function' &&
        triggeredBy.closest('#cart-icon-bubble, a[href="/cart"], a[href^="/cart?"]');

      if (!explicitCartTrigger && !hasRecentCartIntent()) {
        return;
      }

      return originalOpen.apply(this, arguments);
    };

    CartDrawer.prototype.__sootheeIntentGuarded = true;
  }

  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(guardNativeCartDrawer).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', guardNativeCartDrawer);
})();
